<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { DocHeading } from '@/types/docs'

const props = defineProps<{
  headings: DocHeading[]
  activeId: string | null
}>()

const { t } = useI18n()
</script>

<template>
  <nav
    aria-label="On this page"
    class="w-full py-4"
  >
    <p class="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
      {{ t('docs.article.on_this_page') }}
    </p>

    <ul
      v-if="headings.length > 0"
      role="list"
      class="space-y-1"
    >
      <li
        v-for="heading in headings"
        :key="heading.id"
      >
        <a
          :href="`#${heading.id}`"
          class="block text-xs transition-colors py-0.5"
          :class="[
            heading.level === 3 ? 'pl-3' : '',
            activeId === heading.id
              ? 'text-emerald-400 font-semibold'
              : 'text-slate-400 hover:text-white',
          ]"
          :aria-current="activeId === heading.id ? 'true' : undefined"
        >
          {{ heading.text }}
        </a>
      </li>
    </ul>

    <p
      v-else
      class="text-xs text-slate-600 italic"
    >
      —
    </p>
  </nav>
</template>
